module.exports = __webpack_public_path__ + "static/media/PDF_90.b38a9f20.pdf";